<template>
  <div class="docbox">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/buergerkonto">Bürgerkonto</router-link>
      <router-link to="/buergerkonto/dokumentenbox">Dokumentenbox</router-link>
    </Breadcrumb>
    <div class="docbox__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/buergerkonto" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="docBox" color="detailed" class="hide-mobile"/>
          <Headline subline="Ihre Dateien" headline="Bürgerkonto-Dokumentenbox" />
        </div>
        <div class="headline-link__right hide-mobile">
          <form @submit.prevent="" class="input-wrapper">
            <input type="search" placeholder="Dokumente durchsuchen..." v-model="searchTerm">
            <Icon icon="search"/>
          </form>
        </div>
      </div>
    </div>
    <div class="docbox__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs">
        <div class="docbox__content__left col-xs-12 col-md-8">
          <div v-if="userDocs.length < 1" class="no-docs">
            <Icon icon="docBox" color="detailed" />
            <div class="text">
              <h6>Keine Dokumente</h6>
              <p>Es befinden sich aktuell keine Dokumente & Dateien in Ihrer Dokumentenbox</p>
            </div>
          </div>

          <!-- Dokumentenreiter -->
          <div v-else class="documents" v-for="folder in folders" :key="folder.id" v-show="folder.id == activeFolder.id">
            <div class="documents__header">
              <h6>{{ folder.name }} ({{ folder.docs.length }})</h6>
              <div class="add-file" @click="toggleMessageModal" title="Datei / Dokument hinzufügen">
                <Icon icon="fileAdd" />
              </div>
            </div>
            <Modal v-if="toggleMessage" @closeModal="toggleMessageModal" :outside="true">
              <Card padding="35px" class="modal-new">
                <Headline subline="Datei hinzufügen" headline="Leider nicht möglich"/>
                <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
              </Card>           
            </Modal>
            <div class="documents__content">
              <!-- Dokument -->
              <div class="document" v-for="doc in folderDocs" :key="doc.id" @click="showDocModal(doc.id)">
                <div class="document__content" :class="{'new' : !doc.seen}">
                  <Icon icon="file" />
                  <p>{{ doc.name }}</p>
                  <span>ANZEIGEN</span>
                  <Icon icon="wait" />
                </div>
              </div>
              <Modal v-if="showModal && activeDoc" @closeModal="toggleModal" :outside="true">
                <Card padding="35px" class="modal-new">
                  <h3>Dokumenten-Details</h3>
                  <table>
                    <tr>
                      <td>Dateiname:</td>
                      <td>{{ activeDoc.name }}</td>
                    </tr>
                    <tr>
                      <td>Hinzugefügt am:</td>
                      <td>{{ activeDoc.date }}</td>
                    </tr>
                    <tr>
                      <td>Dateigröße:</td>
                      <td>{{ activeDoc.size }}</td>
                    </tr>
                    <tr>
                      <td>Eigene Datei:</td>
                      <td>{{ activeDoc.extern }}</td>
                    </tr>
                  </table>
                  <Button text="Datei herunterladen" type="primary" class="margin-top--30 margin-bottom--20"/>
                  <Button text="Datei löschen" type="ghost"/>
                </Card>           
              </Modal>
            </div>
          </div>
        </div>

        <!-- Sidebar -->
        <div class="docbox__content__sidebar col-xs-12 col-md-3">
          <div class="margin-bottom--30">
            <div class="nav-element"
              v-for="folder in folders" 
              :key="folder.id"  
              @click="activeFolder = folder" 
              :class="{'selected' : folder == activeFolder}"
              >
              <Icon icon="folder" />
              <div class="text">
                <h6>{{ folder.name }}</h6>
                <p>{{ folder.docs.length }} Dateien</p>
              </div>
            </div>
            <div class="new-folder">
              <Button text="Neuen Ordner erstellen" type="ghost" @click.native="toggleMessageModal"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Teaser illu="dataInput" subline="Ihre Bürgerkonto-Dokumentenbox" headline="Dokumente schneller zur Hand">
      <p>In Ihrer persönlichen Dokumentenbox landen nicht nur alle von Ihnen beantragten Nachweise, Zeugnisse und Bescheide, Sie können auch Ihre eigenen Datei hochladen.
        Dadurch lassen sich diese beim nächsten Online-Service ohne lästiges Suchen bequem und geräteunabhängig von überall auswählen. 
        Zeit sparen wenn es am schnellsten gehen muss!</p>
    </Teaser>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';


export default {
  name: 'Docbox',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
  },
  data() {
    return {
      searchTerm: '',
      showModal: false,
      toggleMessage: false,
      activeFolder: null,
      activeDoc: null,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      folders: 'documents/getAllFolders',
      userDocs: 'documents/getAllDocs',
      getDocsByIds: 'documents/getDocsByIds',
      getDocsByUser: 'documents/getDocsByUser',
      getDocsByTitle: 'documents/getDocsByTitle',
    }),
    folderDocs() {
      return this.userDocs.filter(doc => this.activeFolder.docs.includes(doc.id));
    },
  },
  methods: {
    ...mapActions({
      checkDoc: 'documents/checkDoc',
    }),
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleMessageModal() {
      this.toggleMessage = !this.toggleMessage;
    },
    showDocModal(id) {
      this.activeDoc = this.userDocs.find(doc => doc.id == id);
      this.checkDoc(id);
      this.toggleModal();
    }
  },
  created() {
    this.activeFolder = this.folders[0];
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Docbox.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Docbox/Docbox.vue